import { render, staticRenderFns } from "./interesse.vue?vue&type=template&id=8d3d8cd6&"
import script from "./interesse.vue?vue&type=script&lang=js&"
export * from "./interesse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports